module.exports = __webpack_public_path__ + "img/stake.a95a3179.svg";